// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssetInfoController from "./asset_info_controller"
application.register("asset-info", AssetInfoController)

import InstitutionsController from "./institutions_controller"
application.register("institutions", InstitutionsController)
